import React, { useState } from "react";
import { useRecoilValue } from 'recoil';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Container, Typography, TextField, Button, IconButton, Box, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Select, MenuItem } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { Close, Cancel, Delete, Save, } from '@mui/icons-material';

import { userInfo } from "../../auth/AuthProvider";
import Dialog4Confirm from "./Dialog4Confirm";
import Dialog4Alert from "./Dialog4Alert";
import PropTypes from 'prop-types';
import { isDebug } from "../../utils";
import { Transition, BoardType, UserType, UseYn, numberCheck } from './ControlUtils'
import { useBoardManageItemQuery, useBoardManageItemPostMutation, useBoardManageItemPutMutation, useBoardManageItemDeleteMutation } from "../../hooks/useBoard/useBoardManageQuery";


export default function ControlWriteBoard (props) {
  const navigate = useNavigate();
  const auth = useRecoilValue(userInfo);
  const { t } = useTranslation();
  const { manageId, open, closeEditDialog, refMessage} = props;
  const isLoadingRef = React.useRef(false);
  const refConfirm = React.useRef(null);
  const refAlert = React.useRef(null);
  
  const [ pageTitle ] = React.useState(t('nav.board3'));
  const [ selectBoardType ] = React.useState(BoardType);
  const [ selectUserType ] = React.useState(UserType);
  const [ selectUseYn ] = React.useState(UseYn);
  
  const defaultPostVlues = {ManageId: manageId, BoardName: "", BoardType:"board", NewYn: "N", NewTerm: "7", CommentYn: "N", WriteRole: "system", ReadRole: "system", OrdYn: "N" };
  const [editPost, setEditPost] = useState(defaultPostVlues);

  const { mutate: postBoardManageItem } = useBoardManageItemPostMutation();
  const { mutate: putBoardManageItem } = useBoardManageItemPutMutation();
  const { mutate: deleteBoardManageItem } = useBoardManageItemDeleteMutation();

  const { isError, isLoading, isFetching, isSuccess, error, data } = useBoardManageItemQuery(manageId);
  

  // 게시글 저장 핸들러
  const handleEditPost = () => {
    if(auth.userId === undefined || auth.userId === null || auth.userId === '') {
      refMessage.openMessage(`${t('error.notlogin')}`);
      setTimeout(() => {
        navigate(`/login`);
      }, process.env.REACT_APP_REDIRECT_TIME_WAIT);
    }
    else if (isValidation()) {
      refConfirm.current.showMessageBox(`${t('button.save')}`, `${t('alert.saveconfirm')}`, (result) => {
        if(result) {
          if (isLoadingRef.current)  return;
          isLoadingRef.current = true;

          // 저장하고
          if(manageId > 0)
          {
            putBoardManageItem(editPost, {
              onSuccess: () => {
                refAlert.current.showMessageBox(t('button.save'), t('message.updatecomplet'));
              },
              onError: (err) => {
                let msg = err?.response?.data.detail[0].msg || `${t('error.notprosess')}`;
                refAlert.current.showMessageBox(t('error.title'), msg);
              },
            });
          }
          else
          {
            postBoardManageItem(editPost, {
              onSuccess: () => {
                refAlert.current.showMessageBox(t('button.save'), t('message.savecomplet'));
              },
              onError: (err) => {
                let msg = err?.response?.data.detail[0].msg || `${t('error.notprosess')}`;
                refAlert.current.showMessageBox(t('error.title'), msg);
              },
            });
          }
          
          isLoadingRef.current = false;
          setEditPost(defaultPostVlues);
          closeEditDialog(true); // 다이얼로그 닫기
        }
      });
    }
  };

  // 게시글 삭제 핸들러
  const handleDeletePost = (index) => {
    if(auth.userId === undefined || auth.userId === null || auth.userId === '') {
      refMessage.openMessage(`${t('error.notlogin')}`);
      setTimeout(() => {
        closeEditDialog(false);
        navigate(`/login`);
      }, process.env.REACT_APP_REDIRECT_TIME_WAIT);
    }
    else if (isValidation()) {

      refConfirm.current.showMessageBox(`${t('button.delete')}`, `${t('alert.delete')}`, (result) => {
        if(result) {
          if (isLoadingRef.current)  return;
          isLoadingRef.current = true;

          // 삭제하고
          deleteBoardManageItem(editPost.ManageId, {
            onSuccess: () => {
              refAlert.current.showMessageBox(t('button.delete'), t('message.deletecomplet'));
            },
          });
          
          isLoadingRef.current = false;
          setEditPost(defaultPostVlues);
          closeEditDialog(true);; // 다이얼로그 닫기
        }
      });
      
    }
  };

  const isValidation = () => {
    debugger;
    if(manageId > 1 && (editPost?.ManageId === undefined || editPost?.ManageId === null || editPost?.ManageId < 1))
    {
      refAlert.current.showMessageBox(t('alert.title'), `[${t('field.manageid')}] ${t('error.emptyvalue')}`);
      return false;
    }
    
    if(editPost?.BoardName === undefined || editPost?.BoardName === null || editPost?.BoardName === '')
    {
      refAlert.current.showMessageBox(t('alert.title'), `[${t('field.boardname')}] ${t('error.emptyvalue')}`);
      return false;
    }
    
    if(editPost?.BoardType === undefined || editPost?.BoardType === null || editPost?.BoardType === '')
    {
      refAlert.current.showMessageBox(t('alert.title'), `[${t('field.boardtype')}] ${t('error.emptyvalue')}`);
      return false;
    }
    if(editPost?.BoardType !== 'faq' && editPost?.BoardType !== 'qna' && editPost?.BoardType !== 'board')
    {
      refAlert.current.showMessageBox(t('alert.title'), `[${t('field.boardtype')}] ${t('error.emptyvalue')}`);
      return false;
    }
    
    if(editPost?.WriteRole === undefined || editPost?.WriteRole === null || editPost?.WriteRole === '')
    {
      refAlert.current.showMessageBox(t('alert.title'), `[${t('field.writerole')}] ${t('error.emptyvalue')}`);
      return false;
    }
    if(editPost?.WriteRole !== 'system' && editPost?.WriteRole !== 'master' && editPost?.WriteRole !== 'basic')
    {
      refAlert.current.showMessageBox(t('alert.title'), `[${t('field.writerole')}] ${t('error.emptyvalue')}`);
      return false;
    
    }
    if(editPost?.ReadRole === undefined || editPost?.ReadRole === null || editPost?.ReadRole === '')
    {
      refAlert.current.showMessageBox(t('alert.title'), `[${t('field.readrole')}] ${t('error.emptyvalue')}`);
      return false;
    }
    if(editPost?.ReadRole !== 'system' && editPost?.ReadRole !== 'master' && editPost?.ReadRole !== 'basic')
    {
      refAlert.current.showMessageBox(t('alert.title'), `[${t('field.readrole')}] ${t('error.emptyvalue')}`);
      return false;
    }
    return true;
  };

  // 다이얼로그 닫기
  const handleCloseDialog = () => {
    setEditPost(defaultPostVlues);
    closeEditDialog(false);
  };

  
  React.useEffect(() => {
    return () => {
      setEditPost(defaultPostVlues);
    }
  }, [open])

  React.useEffect(() => {
      try {
          if(data?.response_code === 201)
          {
            setEditPost(data?.data);
          }
          else if (data?.message !==null && data?.message?.length > 0)
          {
            setEditPost(defaultPostVlues);
            refMessage?.showMessageBox(`${t('error.title')}`, JSON.stringify(data.message));
          }
          else if(isSuccess === false && (error !== undefined || error !== null || JSON.stringify(error) !== null ))
          {
            setEditPost(defaultPostVlues);
            if (isDebug()) console.log("useQueryBind[BWF]", new Date().toISOString(), error);
          }
      }
      catch(err) {
        console.log("useQueryExce[BWF]", new Date().toISOString(), err);
      }
  }, [isError, isLoading, isFetching, isSuccess, error, data]);

    
  return (
    <Container maxWidth="sm" style={{ marginTop: "10px" }}>

      {/* 게시글 수정 다이얼로그 */}
      <Dialog open={open} TransitionComponent={Transition} fullWidth={true} maxWidth={"md"} 
              onClose={handleCloseDialog} 
              scroll="paper"
              aria-labelledby="scroll-dialog-title"
              aria-describedby="scroll-dialog-description"
      >
        <DialogTitle>
          <Typography variant="h5" gutterBottom align="center">
            {pageTitle}
            &nbsp;&nbsp;
            {manageId > 0 ?
                    t('button.modify')
                    : t('button.registration')
                }
        </Typography>

        </DialogTitle>
        <Box position="absolute" top={0} right={0}>
            <IconButton onClick={() => handleCloseDialog()}>
                <Close />
            </IconButton>
        </Box>
        
        <DialogContent dividers>

          <Container sx={{ p: 1 }}>
            <Grid container alignItems="center" spacing={1} sx={{  '--Grid-borderWidth': '1px',
                                                                      borderColor: 'divider',
                                                                      '& > div.divline': {
                                                                          borderTop: 'var(--Grid-borderWidth) dotted',
                                                                          borderColor: 'divider',
                                                                          lineHeight: '3px',
                                                                          height: '3px',
                                                                      },
              }}>

                <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                  <Typography component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                    ※ {t('field.boardname')} 
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                  <TextField id="board_reg_boardname" label="" variant="outlined" size="small" disabled={false} fullWidth
                          value={editPost.BoardName} onChange={(e) => setEditPost({...editPost, BoardName:e.target.value})} />
                </Grid>
                
                <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                  <Typography id="boardtype-select-small-label" component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                    ※ {t('field.boardtype')}
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                  <FormControl sx={{ m: 0, p: 0, minWidth: 200 }} size="small">
                    <Select
                        labelId="boardtype-select-small-label"
                        id="boardtype-select-small"
                        placeholder={t('others.selectone')}
                        value={editPost.BoardType || ''}
                        onChange={(e) => setEditPost({...editPost, BoardType:e.target.value}) }
                        size="small"
                    >
                      <MenuItem value="">
                          <em>{t('others.selectone')}</em>
                      </MenuItem>
                      {selectBoardType ? selectBoardType.map(item => {
                        return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                      })
                      : null
                      }
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                  <Typography id="newyn-select-small-label" component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                    {t('field.newyn')}
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                  <FormControl sx={{ m: 0, p: 0, minWidth: 200 }} size="small">
                    <Select
                        labelId="newyn-select-small-label"
                        id="newyn-select-small"
                        placeholder={t('others.selectone')}
                        value={editPost.NewYn || ''}
                        onChange={(e) => setEditPost({...editPost, NewYn:e.target.value}) }
                        size="small"
                    >
                      <MenuItem value="">
                          <em>{t('others.selectone')}</em>
                      </MenuItem>
                      {selectUseYn ? selectUseYn.map(item => {
                        return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                      })
                      : null
                      }
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                  <Typography id="newterm-select-small-label" component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                    {t('field.newterm')}
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                  <TextField id="board_reg_newterm" label="" variant="outlined" size="small"  
                        value={editPost.NewTerm} onChange={(e) => setEditPost({...editPost, NewTerm:numberCheck(e.target.value)})} />
                </Grid>

                <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                  <Typography id="commentyn-select-small-label" component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                      {t('field.commentyn')}
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                  <FormControl sx={{ m: 0, p: 0, minWidth: 200 }} size="small">
                    <Select
                        labelId="commentyn-select-small-label"
                        id="commentyn-select-small"
                        placeholder={t('others.selectone')}
                        value={editPost.CommentYn || ''}
                        onChange={(e) => setEditPost({...editPost, CommentYn:e.target.value}) }
                        size="small"
                    >
                      <MenuItem value="">
                          <em>{t('others.selectone')}</em>
                      </MenuItem>
                      {selectUseYn ? selectUseYn.map(item => {
                        return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                      })
                      : null
                      }
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                  <Typography id="writerole-select-small-label" component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                    ※ {t('field.writerole')}
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                  <FormControl sx={{ m: 0, p: 0, minWidth: 200 }} size="small">
                    <Select
                        labelId="writerole-select-small-label"
                        id="writerole-select-small"
                        placeholder={t('others.selectone')}
                        value={editPost.WriteRole || ''}
                        onChange={(e) => setEditPost({...editPost, WriteRole:e.target.value}) }
                        size="small"
                    >
                      <MenuItem value="">
                          <em>{t('others.selectone')}</em>
                      </MenuItem>
                      {selectUserType ? selectUserType.map(item => {
                        return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                      })
                      : null
                      }
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                  <Typography id="readrole-select-small-label" component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                    ※ {t('field.readrole')}
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                  <FormControl sx={{ m: 0, p: 0, minWidth: 200 }} size="small">
                    <Select
                        labelId="readrole-select-small-label"
                        id="readrole-select-small"
                        placeholder={t('others.selectone')}
                        value={editPost.ReadRole || ''}
                        onChange={(e) => setEditPost({...editPost, ReadRole:e.target.value}) }
                        size="small"
                    >
                      <MenuItem value="">
                          <em>{t('others.selectone')}</em>
                      </MenuItem>
                      {selectUserType ? selectUserType.map(item => {
                        return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                      })
                      : null
                      }
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                  <Typography id="ordyn-select-small-label" component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                      {t('field.ordyn')}
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                  <FormControl sx={{ m: 0, p: 0, minWidth: 200 }} size="small">
                    <Select
                        labelId="ordyn-select-small-label"
                        id="ordyn-select-small"
                        placeholder={t('others.selectone')}
                        value={editPost.OrdYn || ''}
                        onChange={(e) => setEditPost({...editPost, OrdYn:e.target.value}) }
                        size="small"
                    >
                      <MenuItem value="">
                          <em>{t('others.selectone')}</em>
                      </MenuItem>
                      {selectUseYn ? selectUseYn.map(item => {
                        return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                      })
                      : null
                      }
                    </Select>
                  </FormControl>
                </Grid>

            </Grid>
          </Container>

        </DialogContent>

        <DialogActions>

          <Button onClick={handleCloseDialog} startIcon={<Cancel />} color="primary" variant="contained" sx={{ paddingLeft: '35px', paddingRight: '35px', marginRight: '30px', marginTop: '5px' }} >
          {t('button.cancel')}
          </Button>
          {manageId > 1 ?
          <Button onClick={handleDeletePost} startIcon={<Delete />} color="primary" variant="contained" sx={{ paddingLeft: '35px', paddingRight: '35px', marginRight: '30px', marginTop: '5px' }} >
          {t('button.delete')}
          </Button> : null }
          <Button onClick={handleEditPost} startIcon={<Save />} color="secondary" variant="contained" sx={{ paddingLeft: '35px', paddingRight: '35px', marginRight: '30px', marginTop: '5px' }} >
            {t('button.save')}
          </Button>

        </DialogActions>
      </Dialog>
      <Dialog4Alert ref={refAlert} />
      <Dialog4Confirm ref={refConfirm} />
    </Container>
  );
};

ControlWriteBoard.propTypes = {
  manageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), 
  open: PropTypes.bool.isRequired, 
  closeEditDialog: PropTypes.func.isRequired, 
  refMessage: PropTypes.object
};